"use client"
import styled from "@emotion/styled";
import { GetPageQuery } from "apollo";
import { Article } from "lib/articles";
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import QRCodeCharge from "pazChargeComponents/Home/QRCodeCharge";
import ImageWithTextCharge from "pazChargeComponents/public-charging-stations/ImageAndTextCharge";
import { extractProperty } from "utils";
import ArticleTabMenu, { ArticlesCategories } from "./ArticleTabMenu";

const StyledPageWrapper = styled.div`
position: relative;
`;

type Props = {
    data: GetPageQuery,
    articles: Article[]
}
function UsefulInformationChargePage({ data, articles }: Props) {

    const pageHeader = extractProperty(data.page, "pageHeader")![0]
    const articlesByCategory: ArticlesCategories = {
        allArticles: articles,
        commercialArticles: articles.filter(({ categories }) => Array.isArray(categories) && categories.find(cat => cat === "מסחרי")),
        publicArticles: articles.filter(({ categories }) => Array.isArray(categories) && categories.find(cat => cat === "ציבורי")),
    }
    return (
        <>
            <QRCodeCharge showScrollIcon={true} />
            <ImageWithTextCharge data={pageHeader} titleMargin={false} spaceBetweenTextToLine={5} />
            <ContainerWrapper>
                <StyledPageWrapper>
                    <ArticleTabMenu articlesByCategory={articlesByCategory} moreArticles={articles} />
                </StyledPageWrapper>
            </ContainerWrapper>
        </>);
}
export default UsefulInformationChargePage;
